<template>
    <b-modal :id="id" dialog-class="modal-sm" @show="show" @shown="shown" no-close-on-backdrop>
        <template slot="modal-header">
            <span>資料匯入</span>
            <b-button class="close" @click="cancel()">
                <b-icon-x></b-icon-x>
            </b-button>
        </template>
        <b-overlay>
            <file-upload :url="url" @ok="ok"></file-upload>
        </b-overlay>
        <template slot="modal-footer">
            <a v-if="empty_sample" :href="sample" class="btn btn-default"><b-icon-arrow-down></b-icon-arrow-down>範本下載</a>
            <b-button variant="secondary" @click="cancel()"><b-icon-x></b-icon-x>關閉</b-button>
        </template>
    </b-modal>
</template>

<script>
    export default {
        name: 'inputmodal',
        props: ['id', 'sample', 'url'],
        computed: {
            empty_sample: function () { return this.sample; },
        },
        methods: {
            show: function (e) { this.$emit('show', e); },
            shown: function (e) { this.$emit('shown', e); },
            cancel: function () { this.$bvModal.hide(this.id); },
            ok: function (e) {
                this.$bvToast.toast('上傳' + e.res.data.totel + ' 新增' + e.res.data.success, { title: '上傳完成', variant: 'success', solid: true });
                this.$emit('ok', e);
            },
        }
    };
</script>

<style>
</style>